angular
    .module('WizApp')
    .component('homeDynamicRegisterLightbox', {
        controller: [
            '$scope',
            '$rootScope',
            'EVENT_NAMES',
            'LightboxStamp',
            'CookiesConsentService',
            ($scope, $rootScope, EVENT_NAMES, LightboxStamp, CookiesConsentService) => {
                const vm = LightboxStamp(this, $scope);
                const allConsents = {
                    facebook:true,
                    google:true,
                    facebook_pixel:true,
                    hotjar:true
                };

                vm.SCREENS = {
                    register: 'register',
                    login: 'login',
                    facebookMail: 'facebookMail'
                };

                vm.screen = vm.SCREENS.register;
                vm.toggleLogin = toggleLogin;
                vm.isSidePanelEnabled = isSidePanelEnabled;
                vm.setAllConsents = setAllConsents;

                vm.type = null;

                $rootScope.$on(EVENT_NAMES.homeDynamicRegisterLightbox.open, (event, { cta }) => {
                    vm.screen = cta === vm.SCREENS.login ? vm.SCREENS.login : vm.SCREENS.register;
                    vm.setAllConsents();
                    vm.open();
                });

                $scope.$on(EVENT_NAMES.facebookConnect.missingEmail, event => {
                    event.stopPropagation();
                    vm.screen = vm.SCREENS.facebookMail;
                });


                function toggleLogin() {
                    vm.screen = vm.screen === vm.SCREENS.login ? vm.SCREENS.register : vm.SCREENS.login;
                }

                function isSidePanelEnabled() {
                    return vm.screen === vm.SCREENS.register;
                }

                function setAllConsents() {
                    CookiesConsentService.getCookiesConsent()
                        .then(data => {
                            return data === null ? CookiesConsentService.setCookiesConsent(allConsents) : null;
                        })
                    ;
                }

                return vm;
            }
        ],
        // language=HTML
        template:
        `
            <div
                class="lightbox lightbox job-dynamic-register-lightbox"
                data-ng-class="{'lightbox--with-side-panel': $ctrl.isSidePanelEnabled()}"
                data-ng-if="$ctrl.isOpen"
                data-ng-click="$ctrl.close()"
            >
                <div class="lightbox__inner" data-ng-click="$event.stopPropagation()">
                    <div class="block block--radius-sm-up block--no-padding block--no-margin-bottom position-relative">
                        <span class="lightbox__close-btn" data-ng-click="$ctrl.close()">
                            <span class="icon-cross"></span>
                        </span>
                        
                        <div class="flex--md-up" data-ng-if="$ctrl.screen == $ctrl.SCREENS.register">
                            
                            <div class="flexed block block--no-margin-bottom padding-gutter padding-vertical-large--sm-up padding-horizontal-larger--sm-up">
                                <h3
                                    class="text-center"
                                    data-ng-if="$ctrl.job && $ctrl.job.title && !$ctrl.proposal"
                                >
                                    {[:: 'wizbii.registerlayer.messages.title.signinonwizbii' | trans ]}<br />
                                    <span
                                        class="font-weight-really-medium text-italic"
                                        data-ng-if="$ctrl.job"
                                    >{[:: 'wizbii.registerlayer.messages.title.andbecome' | trans ]} {[:: $ctrl.job.title ]}</span>
                                </h3>
                                
                                <h3
                                    class="text-center"
                                    data-ng-if="$ctrl.proposal == 'alert'"
                                >
                                    {[:: 'wizbii.registerlayer.messages.title.joinusmail' | trans ]}
                                </h3>
                                
                                <h3
                                    class="text-center"
                                    data-ng-if="$ctrl.proposal == 'search'"
                                >
                                    {[:: 'wizbii.registerlayer.messages.title.joinusjob' | trans ]}
                                </h3>
                                
                                <h3
                                    class="text-center"
                                    data-ng-if="!$ctrl.job && !$ctrl.proposal"
                                >
                                    {[:: 'wizbii.registerlayer.messages.title.joinus' | trans ]}
                                </h3>

                                <register-form></register-form>

                                <hr class="margin-top-large margin-bottom-gutter-ish" />

                                <div class="text-center text-darker font-weight-regular font-size-base-small font-size-base--sm-up">
                                    {[:: 'wizbii.registerlayer.messages.label.accountexists' | trans ]}, 
                                    <a data-ng-click="$ctrl.toggleLogin()">{[:: 'wizbii.registerlayer.messages.label.login' | trans ]}</a> !
                                </div>
                            </div>

                            <div
                                data-ng-if="$ctrl.isSidePanelEnabled()"
                                class="
                                    lightbox__side-panel
                                    bg-v35-blue-gradient
                                    block
                                    block--no-margin-bottom
                                    block--no-radius
                                    padding-vertical-large--sm-up
                                    padding-horizontal-larger--sm-up
                                    padding-large--md-up
                                    padding-top-fifty--md-up
                                    text-left
                                "
                            >
                                <h3 class="margin-right-gutter-double margin-bottom-gutter">
                                    {[:: 'wizbii.registerlayer.messages.label.findjob' | trans ]}
                                </h3>
                                
                                <h5>{[:: 'wizbii.registerlayer.messages.label.platform' | trans ]}</h5>
                                
                                <ul class="job-dynamic-register-lightbox__company-logos">
                                    <li>
                                        <img
                                            src="/bundles/wizbiicore/images/v35/logo-white-Accor.svg"
                                            alt=""
                                        />
                                    </li>
                                
                                    <li>
                                        <img
                                            src="/bundles/wizbiicore/images/v35/logo-white-Decathlon.svg"
                                            alt=""
                                        />
                                    </li>
                                
                                    <li>
                                        <img
                                            src="/bundles/wizbiicore/images/v35/logo-white-Thales.svg"
                                            alt=""
                                        />
                                    </li>
                                
                                    <li>
                                        <img
                                            src="/bundles/wizbiicore/images/v35/logo-white-BDO.svg"
                                            alt=""
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div
                            data-ng-if="$ctrl.screen == $ctrl.SCREENS.login"
                            class="padding-gutter padding-vertical-large--sm-up padding-horizontal-larger--sm-up"
                        >
                            <h3 class="text-center">
                                {[:: 'wizbii.registerlayer.messages.title.login' | trans ]} :)
                            </h3>

                            <login-form></login-form>

                            <hr class="margin-top-large margin-bottom-gutter-ish" />
                            
                            <div class="text-center text-darker font-weight-regular font-size-base-small font-size-base--sm-up">
                                {[:: 'wizbii.registerlayer.messages.label.noaccount' | trans ]}, 
                                <a data-ng-click="$ctrl.toggleLogin()">{[:: 'wizbii.registerlayer.messages.label.signup' | trans ]}</a> !
                            </div>
                        </div>

                        <div
                            ng-if="$ctrl.screen == $ctrl.SCREENS.facebookMail"
                            class="padding-gutter padding-vertical-large--sm-up padding-horizontal-larger--sm-up"
                        >
                            <facebook-mail-form></facebook-mail-form>
                        </div>
                    </div>
                </div>
            </div>
        `
    });
